<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <svg
    :width="width"
    :height="height"
    class="group"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :class="styles"
      d="M11.0146 3.98535L19.0146 11.9854L11.0146 19.9854"
      stroke-width="3"
    />
    <path :class="styles" d="M18 12L2 12" stroke-width="3" />
  </svg>
</template>

<script lang="ts" setup>
import { defineProps, computed, toRefs } from "vue";
export interface IconLinkProps {
  color?: string;
  width?: string;
  height?: string;
  classes?: string;
}

const props = withDefaults(defineProps<IconLinkProps>(), {
  color: "white",
  width: "100%",
  height: "100%",
});

const { color, width, height, classes } = toRefs(props);
const styles = computed(() => {
  return `${color.value} group-hover:stroke-orange transition-colors ${classes?.value}`;
});
</script>
